/**
 * Gêneros: the noun, pick `o` or `a`.
 *
 * The mirror of Der·Die·Das and the same component, one button lighter.
 * Portuguese does not have a smaller version of the German idea here — it
 * simply never produces a third gender, which is the first thing German makes
 * this learner carry and Portuguese takes away.
 */
import { ArticleChoiceFront } from '@/components/practice/GenderedNounCard';
import { PORTUGUESE_ARTICLES } from '@/lib/gender';

import type { CardFrontProps } from '../types';

import type { SubstantivoPayload } from './types';

export function CardFront({ card, onAnswer }: CardFrontProps<SubstantivoPayload>) {
  return <ArticleChoiceFront card={card} onAnswer={onAnswer} articles={PORTUGUESE_ARTICLES} />;
}
